import {Component} from 'react'
import renderRoutes from 'react-router-config/es/renderRoutes'

export default class PurchaserContainer extends Component {
  render() {
    return renderRoutes(this.props.route.routes)
  }
}
